import {get} from 'lodash'
import {createProjectModel} from 'crm/utils/project-model'
import {
    storeDrainageCode,
    storeChannels,
    updateStoreDrainageCode,
    updateGroupChatLink,
} from '../../../../../../service/drainage'

const model = createProjectModel({
    namespace: 'drainageCodeModal',

    state: {
        tableData: {},
    },

    effects: {
        // 门店引流码
        *storeDrainageCode({payload}, {select, put, call}) {
            const {tableData} = yield select((allState) => allState[model.namespace])

            const newParams = {
                ...tableData.params,
                offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                limit: tableData.pagination.pageSize,
            }

            const res = yield call(storeDrainageCode, {
                id: payload.id,
                params: newParams,
            })

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = get(res, 'pagination.rows_found', 0)
                },
            })
        },
        *updateGroupChatLink({payload}, {call}) {
            return yield call(updateGroupChatLink, payload)
        },
        *storeChannels({payload}, {call}) {
            return yield call(storeChannels, payload)
        },
        *updateStoreDrainageCode({payload}, {call}) {
            return yield call(updateStoreDrainageCode, payload)
        },
    },
})

export default model
